export default function Cta() {
  return (
    <section className="w-full px-4 pb-16 md:px-6 md:pb-20">
      <div className="mx-auto w-full max-w-7xl">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-primary-500 via-primary-600 to-accent-600 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="absolute -left-10 -top-12 h-48 w-48 rounded-full bg-background-50/10 blur-2xl" />
          <div className="absolute -bottom-14 -right-8 h-52 w-52 rounded-full bg-accent-400/30 blur-2xl" />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="text-2xl font-extrabold text-background-50 md:text-4xl">
              把想看的 91免费内容一次装进收藏
            </h2>
            <p className="mt-3 text-sm text-background-50/85 md:text-base">
              精选合集、瓜料汇总、内容大全与素材库都已分区摆好，从上方热榜或合集开始逛起即可。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#collections"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 sm:w-auto"
              >
                <i className="ri-box-3-fill" /> 逛精选合集
              </a>
              <a
                href="#hot"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-50/50 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10 sm:w-auto"
              >
                <i className="ri-fire-fill" /> 看今日热榜
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}